module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority/image-grid/grid-08-0027dab263ec129258b2074a256665cb.jpg";